import React, { FC, useCallback, useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { PropsType } from './types';
import { useTranslation } from 'react-i18next';

const showValue = (value: string | number, additionalClassName: string) => {
    if (!additionalClassName) {
        return;
    }
    document?.querySelector(`.${additionalClassName}`)?.setAttribute('data-before', `${value}`);
};

const FilterContainer: FC<PropsType> = ({
    id,
    items,
    label,
    helpMessage,
    onOpenExamples,
    onChange,
    value,
    name,
    isHiddenExamples,
    isOpenExamples,
    additionalClassName,
}) => {
    const { t } = useTranslation();

    const handleChange = (event: React.SyntheticEvent, newValue: string | number) => {
        const value = newValue as string;
        openExamples(false, value);
        onChange(name, value);
    };

    const showSelectedItem = useCallback(
        (newValue: string | number) => {
            const indicator = document.querySelector(`#${id} .MuiTabs-indicator`) as HTMLElement;
            const selectedItem = items.find((item) => item.value === newValue);
            if (indicator) {
                indicator.style.backgroundColor = selectedItem?.backgroundColor as string;
            }
            if (!additionalClassName) {
                return;
            }
            setTimeout(() => showValue(value, additionalClassName), 100);
        },
        [additionalClassName, id, items, value],
    );

    const openExamples = (force: boolean, newValue?: string) => {
        if (isHiddenExamples && !force && !isOpenExamples) {
            return;
        }
        const selectedValue = newValue || value;
        const selectedItem = items.find((item) => item.value === selectedValue);
        onOpenExamples({
            label: selectedItem?.label ?? items?.[0].label,
            id: selectedItem?.id ?? items?.[0].id,
        });
    };

    useEffect(() => {
        setTimeout(() => {
            showSelectedItem(value);
        }, 0);
    }, [showSelectedItem, value]);

    return (
        <Box className="filter-container">
            <Box className="filter-container-header">{label}</Box>
            <Box className="filter-container-body">
                <Tabs
                    className="filter-container-body-tabs"
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    id={id}
                    style={{ overflow: 'unset' }}
                >
                    {items.map((item) => (
                        <Tab
                            key={item.value}
                            label={item.label}
                            className={value === item.value ? (additionalClassName ?? '') : ''}
                            style={{
                                backgroundColor: item.backgroundColor,
                                color: item.color,
                                overflow: 'unset',
                            }}
                            iconPosition="start"
                            value={item.value}
                        />
                    ))}
                </Tabs>
                <Box className="filter-container-body-description">
                    {helpMessage}{' '}
                    <button onClick={() => openExamples(true)}>
                        {t('web_app.additiona_settings.see_examples')}
                    </button>
                </Box>
            </Box>
        </Box>
    );
};

export default FilterContainer;
